<template>
    <b-container fluid>
        <b-row>
            <b-col>
                <app-title text="Página de Soporte"></app-title>
            </b-col>
        </b-row>
        <b-tabs>
            <b-tab title="Tickets" active class="mt-3">
                <router-view></router-view>
            </b-tab>
            <b-tab title="Tickets finalizados" class="mt-3">
                <app-tickets-finalized />
            </b-tab>
        </b-tabs>
    </b-container>
</template>
<script>
import TicketsFinalized from './TicketsFinalized.vue'
import TicketForm from './TicketForm'
export default {
    components: {
        appTicketForm: TicketForm,
        appTicketsFinalized: TicketsFinalized,
    },
}
</script>
